import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import {history} from "../../../utils/history";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";
import ReactFlagsSelect from "react-flags-select";
import Translate from "../../../utils/Translate";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class PainPatient2FAComposed extends Component {
    constructor(props) {
        super(props);
        if (authenticationService.currentUserValue) {
            this.props.history.push(appendIchilovQuery('/dashboard'))
        }
        this.recaptchaRef = React.createRef()

        this.state = {
            twoFA: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
            phone: "",
            phoneSecret: "",
            ID_passport: "",
            resend: false,
        }
    }

    componentDidMount() {
        let {phone, phoneSecret, ID_passport} = this.state
        if (this.props.location.state && this.props.location.state.data) {
            ID_passport = this.props.location.state.data.ID_passport
            phone = this.props.location.state.data.Phone_num1
            phoneSecret = phone.substring(phone.length - 4, phone.length) + "******"
        }
        this.setState({phone, phoneSecret, ID_passport})
    }

    initValidation = async () => {
        let {t} = this.props

        let validationSchema = Yup.object().shape({twoFA: Yup.string().required(t('defaults.TwoFA.auth_cd_req'))})


        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }


    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }

    onSubmitResend = async () => {
        this.setState({resend: true})
        await this.onSubmit()

    }

    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {ID_passport, phone, twoFA, resend} = this.state

        if (resend) {
            let response = await authenticationService.PatientLogin(ID_passport, phone, reCaptchaToken);
            if (response.status < 400) {
                this.setState({resend: false})
            }
        } else {
            let response = await authenticationService.submit2fa(twoFA, reCaptchaToken);
            if (response.status < 400) {

                let data = response.data

                if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                    let patientInfo = data
                    history.push({
                        pathname:appendIchilovQuery(`/pain_patient_self_onboard`) ,
                        state: {
                            patientInfo,
                            from: {
                                fromPath: `/pain_patient_2FA`,
                            }
                        },
                    })
                } else {
                    this.setState({
                        twoFA: '',
                        isErr: true,
                        errMessage: response.data ? response.data.message : t('defaults.login.connectionError'),
                    })
                }
            } else {
                this.setState({
                    twoFA: '',
                    isErr: true,
                    errMessage: response.data ? response.data.message : t('defaults.login.connectionError'),
                })
            }
        }
    }

    setMFA = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({twoFA: e.target.value.trim()})
        utils.set(auth, 'twoFA', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'twoFA')) {
            utils.set(errorsOnSave, 'twoFA', utils.get(errors, 'twoFA'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    resendCode = async () => {
        let {ID_passport, phone, reCaptchaToken} = this.state

        let response = await authenticationService.PatientLogin(ID_passport, phone, reCaptchaToken);
        if (response.status < 400) {
        }
    }

    setRecaptcha(reCaptchaToken) {

        this.setState({reCaptchaToken: reCaptchaToken})

    }

    async onSelectFlag(e) {
        e = e && e.length>0?e:"he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    render() {
        let {t} = this.props
        let phone = ""
        let phoneSecret = ""
        if (this.props.location.state && this.props.location.state.data) {
            phone = this.props.location.state.data.Phone_num1
            phoneSecret = phone.substring(phone.length - 4, phone.length) + "******"
        }
        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-right-changeLang'}>

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }
                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-2fa-Leumit'}>{t('defaults.TwoFA.TwoFA')}</label>
                    <label
                        className={'sade-validation-label'}>{t('defaults.TwoFA.TwoFA_info')} {phoneSecret}</label>

                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <form method="get">
                                        <input
                                            /*
                                                                                    autoComplete={"on"}
                                            */
                                            className={"sade-registration-input-field"}
                                            placeholder={t('defaults.TwoFA.valid_cd')}
                                            type={"text"}
                                            name={"twoFA"}
                                            value={this.state.twoFA}
                                            onChange={e => this.setMFA(e)}
                                            autoComplete={"one-time-code"}
                                            autoFocus={true}
                                            inputMode={"numeric"}
                                            pattern={"[0-9]"}
                                            onKeyPress={event => {
                                                if (event.key === 'Enter') {
                                                    this.onSubmit()
                                                }
                                            }}/>
                                    </form>

                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'twoFA') ? "input-pic2" : "input-pic"}
                                        svgname={'lock'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'twoFA')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'twoFA')}/>
                            </div>

                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={this.onSubmit}>{t('defaults.TwoFA.valid')}</button>
                            </div>
                        </div>
                    </div>

                    <div className={'leumit-login-footer-container3'}>
                        <div style={{cursor:'pointer'}} onClick={() => this.props.history.goBack()}>{t('defaults.TwoFA.back_to_login')}</div>
                        <div onClick={this.onSubmitResend}
                             style={{margin: '15px 15px',cursor:'pointer'}}>{t('defaults.TwoFA.resend')}</div>
                    </div>
                    <div className={'leumit-login-form-group loginError red'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.rst_pwd.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                </div>


                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}

let PainPatient2FA = compose(
    withTranslation()
)(PainPatient2FAComposed)

export default PainPatient2FA;
